require("./_index.scss")
module.exports = require('@bone/bone-web-ui')


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web-ui@1/node_modules/_@bone_bone-web-ui-dpl@1.0.6@@bone/bone-web-ui-dpl/index.js
// module id = 1967
// module chunks = 2